import type {
    DatapointConfig,
    CustomData,
    DatapointOptions,
    ActionSource,
} from 'owa-analytics-types';
import * as trace from 'owa-trace';

export interface DatapointConfigWithFunctions<U extends any[]> {
    name: string | ((...args: U) => string);
    customData?: CustomData | ((...args: U) => CustomData);
    options?: DatapointOptions | ((...args: U) => DatapointOptions);
    cosmosOnlyData?: string | ((...args: U) => string);
    actionSource?: ActionSource | ((...args: U) => ActionSource);
}

export default function extractConfig<U extends any[]>(
    config: DatapointConfigWithFunctions<U>,
    middlewareParams: U
): DatapointConfig {
    const name = extractPropertySafely(config, 'name', middlewareParams);
    return {
        name,
        customData: extractPropertySafely(config, 'customData', middlewareParams, name),
        options: extractPropertySafely(config, 'options', middlewareParams, name),
        cosmosOnlyData: extractPropertySafely(config, 'cosmosOnlyData', middlewareParams, name),
        actionSource: extractPropertySafely(config, 'actionSource', middlewareParams, name),
    };
}

function extractPropertySafely<U extends any[]>(
    config: DatapointConfigWithFunctions<U>,
    property: string,
    middlewareParams: U,
    name?: string
): any {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7053 (40,9): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'DatapointConfigWithFunctions<U>'.
    // @ts-expect-error
    if (config[property]) {
        try {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS7053 (45,27): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'DatapointConfigWithFunctions<U>'.
            // @ts-expect-error
            return typeof config[property] === 'function'
                ? // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                  // -> Error TS7053 (49,19): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'DatapointConfigWithFunctions<U>'.
                  // @ts-expect-error
                  config[property].apply(null, middlewareParams)
                : // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                  // -> Error TS7053 (53,19): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'DatapointConfigWithFunctions<U>'.
                  // @ts-expect-error
                  config[property];
        } catch (e) {
            trace.errorThatWillCauseAlert(`${name || 'unknown'} failed to extract ${property}`, e);
        }
    }
    return undefined;
}
